import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedinUser } from "../utils/StorageManager";
import { userType } from "../Components/constants/layout";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isImportFile, setIsImportFile] = useState(false);
  const [isInitialAnalysis, setIsInitialAnalysis] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isStockCheck, setIsStockCheck] = useState(false);
  const [isFinalAnalysis, setIsFinalAnalysis] = useState(false);
  const [isProducts, setIsProducts] = useState(false);
  const [isOrders, setIsOrders] = useState(false);
  const [isSuppliers, setIsSuppliers] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isCustomerOrders, setIsCustomerOrders] = useState(false);
  const [isDashboard, setIsDashboard] = useState(false);
  const [finalMenuItems, setFinalMenuItems] = useState([]);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  let menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "mdi mdi-package-variant",
      link: "/dashboard",
      stateVariables: isProducts,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "products",
      label: "Products",
      icon: "mdi mdi-package-variant",
      link: "/products",
      stateVariables: isProducts,
      click: function (e) {
        e.preventDefault();
        setIsProducts(!isProducts);
        setIscurrentState("Products");
        updateIconSidebar(e);
      },
    },
    {
      id: "orders",
      label: "Orders",
      icon: "mdi mdi-calendar-text",
      link: "/orders",
      stateVariables: isOrders,
      click: function (e) {
        e.preventDefault();
        setIsOrders(!isOrders);
        setIscurrentState("Orders");
        updateIconSidebar(e);
      },
    },
    {
      id: "customerOrders",
      label: "Customer Orders",
      icon: "mdi mdi-calendar-account",
      link: "/customerOrders",
      stateVariables: isCustomerOrders,
      click: function (e) {
        e.preventDefault();
        setIsOrders(!isCustomerOrders);
        setIscurrentState("CustomerOrders");
        updateIconSidebar(e);
      },
    },
    {
      id: "importFile",
      label: "Import file",
      icon: "mdi mdi-file-import-outline",
      link: "/import-file",
      stateVariables: isImportFile,
      click: function (e) {
        e.preventDefault();
        setIsImportFile(!isImportFile);
        setIscurrentState("ImportFile");
        updateIconSidebar(e);
      },
    },
    {
      id: "initialAnalysis",
      label: "Initial Analysis",
      icon: "mdi mdi-alpha-i-circle-outline",
      link: "/initial-analysis",
      stateVariables: isInitialAnalysis,
      click: function (e) {
        e.preventDefault();
        setIsInitialAnalysis(!isInitialAnalysis);
        setIscurrentState("InitialAnalysis");
        updateIconSidebar(e);
      },
    },
    {
      id: "stockCheck",
      label: "Stock Check",
      icon: "mdi mdi-alpha-s-circle-outline",
      link: "/stock-check",
      stateVariables: isStockCheck,
      click: function (e) {
        e.preventDefault();
        setIsStockCheck(!isStockCheck);
        setIscurrentState("StockCheck");
        updateIconSidebar(e);
      },
    },
    {
      id: "finalAnalysis",
      label: "Final Analysis",
      icon: "mdi mdi-alpha-f-circle-outline",
      link: "/final-analysis",
      stateVariables: isFinalAnalysis,
      click: function (e) {
        e.preventDefault();
        setIsFinalAnalysis(!isFinalAnalysis);
        setIscurrentState("FinalAnalysis");
        updateIconSidebar(e);
      },
    },
    {
      id: "suppliers",
      label: "Suppliers",
      icon: "ri-shopping-cart-2-line",
      link: "/suppliers",
      stateVariables: isSuppliers,
      click: function (e) {
        e.preventDefault();
        setIsSuppliers(!isSuppliers);
        setIscurrentState("Suppliers");
        updateIconSidebar(e);
      },
    },
    {
      id: "users",
      label: "Users",
      icon: "ri-group-line",
      link: "/users",
      stateVariables: isUsers,
      click: function (e) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIscurrentState("Users");
        updateIconSidebar(e);
      },
    },
    {
      id: "settings",
      label: "Settings",
      icon: "mdi mdi-cog-outline",
      link: "/settings",
      stateVariables: isSettings,
      click: function (e) {
        e.preventDefault();
        setIsSettings(!isSettings);
        setIscurrentState("Settings");
        updateIconSidebar(e);
      },
    },
  ];

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "ImportFile") {
      setIsImportFile(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "InitialAnalysis") {
      setIsInitialAnalysis(false);
    }
    if (iscurrentState !== "Rejected") {
      setIsRejected(false);
    }
    if (iscurrentState !== "Settings") {
      setIsSettings(false);
    }
    if (iscurrentState !== "StockCheck") {
      setIsStockCheck(false);
    }
    if (iscurrentState !== "FinalAnalysis") {
      setIsFinalAnalysis(false);
    }
    if (iscurrentState !== "Products") {
      setIsProducts(false);
    }
    if (iscurrentState !== "Suppliers") {
      setIsSuppliers(false);
    }
    if (iscurrentState !== "Users") {
      setIsUsers(false);
    }
    if (iscurrentState !== "Orders") {
      setIsOrders(false);
    }
    if (iscurrentState !== "CustomerOrders") {
      setIsCustomerOrders(false);
    }
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
  }, [
    history,
    iscurrentState,
    isImportFile,
    isInitialAnalysis,
    isAuth,
    isRejected,
    isSettings,
    isStockCheck,
    isFinalAnalysis,
    isProducts,
    isSuppliers,
    isUsers,
    isOrders,
    isCustomerOrders,
    isDashboard,
  ]);

  useEffect(() => {
    //Hide menu items depending on user type
    const user = getLoggedinUser();
    if (user && user.user_type <= userType.INITIALANALYSIS) {
      menuItems = menuItems.filter(
        (item) =>
          item.id !== "dashboard" &&
          item.id !== "products" &&
          item.id !== "stockCheck" &&
          item.id !== "finalAnalysis" &&
          item.id !== "settings" &&
          item.id !== "orders" &&
          item.id !== "customerOrders" &&
          item.id !== "suppliers" &&
          item.id !== "users"
      );
    }
    if (user && user.user_type <= userType.STOCKCHECK) {
      menuItems = menuItems.filter(
        (item) =>
          item.id !== "dashboard" &&
          item.id !== "products" &&
          item.id !== "finalAnalysis" &&
          item.id !== "orders" &&
          item.id !== "customerOrders" &&
          item.id !== "suppliers" &&
          item.id !== "users"
      );
    }
    if (user && user.user_type <= userType.FINALANALYSIS) {
      menuItems = menuItems.filter(
        (item) =>
          item.id !== "dashboard" &&
          item.id !== "customerOrders" &&
          item.id !== "orders" &&
          item.id !== "suppliers" &&
          item.id !== "users"
      );
    }

    setFinalMenuItems(menuItems);
  }, []);

  return <React.Fragment>{finalMenuItems}</React.Fragment>;
};
export default Navdata;
